import { render, staticRenderFns } from "./DataRuleList.vue?vue&type=template&id=d259c3c0&"
import script from "./DataRuleList.vue?vue&type=script&lang=js&"
export * from "./DataRuleList.vue?vue&type=script&lang=js&"
import style0 from "./DataRuleList.vue?vue&type=style&index=0&id=d259c3c0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports